module.exports = __webpack_public_path__ + "4c1c21e47459960e0cc8baacbdbb6fe0.svg";